import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box } from '@mui/material';
import Iconify from '../Iconify';

// ModalFrame — desktop centered dialog primitive.
// Sibling: SheetFrame (mobile bottom sheet). Page picks based on viewport.
//
// Responsive: Pattern 3 (sibling components). This one is desktop chrome.

export default function ModalFrame({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth,
  dismissible,
  PaperProps,
}) {
  const paperPropsBase = { sx: { borderRadius: '12px' } };
  const mergedPaperProps = PaperProps
    ? { ...paperPropsBase, ...PaperProps, sx: { ...paperPropsBase.sx, ...(PaperProps.sx || {}) } }
    : paperPropsBase;

  return (
    <Dialog
      open={open}
      onClose={dismissible ? onClose : undefined}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={mergedPaperProps}
    >
      {(title || dismissible) && (
        <DialogTitle sx={{ pr: 6 }}>
          {title}
          {dismissible && (
            <IconButton
              aria-label="Close"
              onClick={onClose}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <Iconify icon="eva:close-outline" />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent>
        <Box>{children}</Box>
      </DialogContent>
      {actions && <DialogActions sx={{ px: 3, pb: 2 }}>{actions}</DialogActions>}
    </Dialog>
  );
}

ModalFrame.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  dismissible: PropTypes.bool,
  PaperProps: PropTypes.object,
};

ModalFrame.defaultProps = {
  title: undefined,
  children: undefined,
  actions: undefined,
  maxWidth: 'sm',
  dismissible: true,
  PaperProps: undefined,
};
